import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from '../../organisms/header/header';

@Component({
  selector: 'app-page-layout',
  templateUrl: './page-layout.component.html',
  styleUrl: './page-layout.component.css',
  imports: [Header, RouterOutlet],
})
export class PageLayoutComponent {}
